import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Text } from "react-internationalization";
import CheckBox from "./CheckBox";

class Step2Med extends Component {
  render() {
    //SONARconst { data, selectedPlan, year } = this.props;
    const { data } = this.props;
    return (
      <React.Fragment>
        <div class="tab-content tab-contentSharp">
          <div id="step3" class="container-Cambia tab-pane active">
            <React.Fragment>
              <h3 class="tab-heading">Current health plan information</h3>
            </React.Fragment>
            <ul class="list-group" id="step3_checklist">
              <strong></strong>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      1.a. Did you turn 65 years of age in the last six months ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      b. Did you enroll in Medicare Part B (Medical) in the last
                      6 months ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      2.a. Are you covered for medical assistance through
                      California's Medi-Cal program ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      b. Will Medi—Cal pay your premiums for this Medicare
                      Supplement policy ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      c. Do you receive benefits from Medi—Cal OTHER THAN
                      payment toward Medicare Part B premium ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      3.a. If had from Medicare plan Other than Medicare Within
                      the past 63 days (for example, a Medicare Advantage plan
                      or Medicare HMO or PPO), fill in your Start and dates
                      below. If you Still covered under the plan, the END DATE
                      blank
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                  <div class="col-md-3">
                    <label for="quesStartDate" class={"control-label"}>
                      Start Date
                    </label>
                    <input
                      type="text"
                      id="quesStartDate"
                      name="quesStartDate"
                      maxLength="10"
                      onChange={this.props.handleDate}
                      onClick={(e) => this.props.handleDates("quesStartDate")}
                      value={data.quesStartDate}
                      placeholder="MM/DD/YYYY"
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div class="col-md-3">
                    <label for="quesEndDate" class={"control-label"}>
                      End Date
                    </label>
                    <input
                      type="text"
                      id="quesEndDate"
                      name="quesEndDate"
                      placeholder="MM/DD/YYYY"
                      maxLength="10"
                      onChange={this.props.handleDate}
                      onClick={(e) => this.props.handleDates("quesEndDate")}
                      value={data.quesStartDate}
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      b. If you Still covered under the Medicare plan, do intend
                      to replace your Current Coverage With this Health Net Life
                      Medicare Supplement plan ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>

              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      If 'Yes', have you received and completed the Notice to
                      Applicant Regarding Replacement Of Medicare Supplement
                      Coverage Or Medicare Advantage form
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      c. Is this your first time in this type of Medicare plan ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      d. Did drop a Medicare Supplement plan to enroll in the
                      Medicare plan ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      4.a. Do you have another Medicare Supplement policy in
                      force ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      b. If so, with what company and what plan do you have ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <input
                      type="text"
                      id="companyName"
                      name="companyName"
                      value={data.companyName}
                      onChange={this.props.handleChange}
                      class={"form-control"}
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      c. If so, do you intend to replace your current Medicare
                      Supplement policy with this policy ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      If 'Yes', have you received and completed the Notice to
                      Applicant Regarding Replacement of Medicare Supplement
                      Coverage or Medicare Advantage form ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      5.a. Have you had coverage under anv other health
                      insurance coverage within the past 63 days (for example,
                      an employer, union or individual plan) ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      b. If so, with what company and what kind of policy ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      c. What are your date of coverage under the other plan?
                      (If you are still covered under the other policy, leave
                      'End date' blank.)
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                  <div class="col-md-3">
                    <label for="quesStartDate2" class={"control-label"}>
                      Start Date
                    </label>
                    <input
                      type="text"
                      id="quesStartDate2"
                      name="quesStartDate2"
                      maxLength="10"
                      onChange={this.props.handleDate}
                      onClick={(e) => this.props.handleDates("quesStartDate2")}
                      value={data.quesStartDate2}
                      placeholder="MM/DD/YYYY"
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                  <div class="col-md-3">
                    <label for="quesEndDate2" class={"control-label"}>
                      End Date
                    </label>
                    <input
                      placeholder="MM/DD/YYYY"
                      type="text"
                      id="quesEndDate2"
                      name="quesEndDate2"
                      maxLength="10"
                      onChange={this.props.handleDate}
                      onClick={(e) => this.props.handleDates("quesEndDate2")}
                      value={data.quesEndDate2}
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>6.a. Are you under the age Of 657?</strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      b. If so, do you have end-stage renal disease (ESRD) ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox />
                  </div>
                </div>
              </li>
            </ul>
            <ul class="list-group" id="step3_checklist">
              <React.Fragment>
                <h3 class="tab-heading mt-3 mb-2">Current Health Statement</h3>
              </React.Fragment>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      1. Are you currently hospitalized or confined to a nursing
                      facility, or have been hospitalized one or more times in
                      the past two years ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox label={"Not Sure"} />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      2. Within the past year, have you had or been treated for
                      any cancers except skin cancer ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox label={"Not Sure"} />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      3. Within the past year, have you been advised have joint
                      replacement surgery that has not vet been performed ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox label={"Not Sure"} />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      4. Within the past two years, have you had an amputaticm
                      caused by a disease, heart surgery, a cerebral vascular
                      accident (stroke), liver disease, or kidney dialysis ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox label={"Not Sure"} />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>5.a. Do you have diabetes ?</strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox label={"Not Sure"} />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      b. Do you take in5uIin or oral medications for treatment
                      of diabetes ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox label={"Not Sure"} />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      6. Are you presently receiving dialysis Or have you ever
                      had a kidney transplant ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox label={"Not Sure"} />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>7. Are you currently taking medication ?</strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox label={"Not Sure"} />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      8. During the past two (2) years, have used oxygen outside
                      Of the hospital or have you been treated in the hospital
                      or for Chronic Obstructive pulmonary disease, Chronic
                      bronchitis, and for emphysema ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox label={"Not Sure"} />
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <label class="custom-label col-md-9" for="step3_chk1">
                    <strong>
                      9. Have smoked or used tobacco product Within the past two
                      (2) years ?
                    </strong>{" "}
                  </label>
                  <div class="col-md-3">
                    <CheckBox label={"Not Sure"} />
                  </div>
                </div>
              </li>
            </ul>
            <button
              class="btn btn-saveNext mt-3 save-next-color"
              id="next2"
              onClick={this.props.redirect}
            >
              <Text id="app.Save_Next" />
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    year: state.webApp.year,
  };
};
export default connect(mapStateToProps)(Step2Med);
